import { DataPlayersAction, DataPlayersActionTypes } from '../types';

export const dataPlayers = (state = {}, action: DataPlayersActionTypes) => { // to review
  const newState = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case DataPlayersAction.UPDATE_DATA_PLAYER:
      if (!newState[action.player.meta.playerId]) {
        newState[action.player.meta.playerId] = {
          meta: {},
          metrics: {},
          events: {
            games: [],
            practices: []
          }
        };
      }
      newState[action.player.meta.playerId] = {
        ...newState[action.player.meta.playerId],
        meta: {
          ...newState[action.player.meta.playerId].meta,
          ...action.player.meta
        },
        metrics: {
          ...newState[action.player.meta.playerId].metrics,
          ...action.player.metrics
        }
      };
      return newState;
    case DataPlayersAction.REPLACE_DATA_PLAYERS:
      return action.players;
    case DataPlayersAction.REPLACE_DATA_PLAYERS_PLAYER_PRACTICES:
      if (!newState[action.playerId]) {
        newState[action.playerId] = {
          meta: {},
          events: {
            games: [],
            practices: []
          }
        };
      }
      newState[action.playerId].events.practices = action.practices;
      return newState;
    case DataPlayersAction.REPLACE_DATA_PLAYERS_PLAYER_GAMES:
      if (!newState[action.playerId]) {
        newState[action.playerId] = {
          meta: {},
          events: {
            games: [],
            practices: []
          }
        };
      }
      newState[action.playerId].events.games = action.games;
      return newState;
    default:
      return state;
  }
};

